<template>
  <div class="insWrapper">
    <!-- 头部 -->
    <div class="siderTitle">
      <div class="contents" v-show="!collapsed">
        <div class="groupTitle">组织机构</div>
      </div>
      <div class="siderIcon">
        <span>共{{ groupNames.length?groupNames.length - 1:0 }}个本级部门</span>
      </div>
      <div style="text-align: center;border-left: 1px solid #eee;border-right: 1px solid #eee;">
        <h-search placeholder="搜索部门名称" @search="groupSearch" @clean="groupClean" v-model="groupSearchText" style="margin-top:10px;height:36px;width:90%;" />
      </div>
    </div>
    <!-- 机构 -->
    <div style="height:700px;overflow-y:auto;width:240px;position: absolute;margin-top: 55px;border: 1px solid #eee;border-top: 0px" id="scrollWrap" v-show="!collapsed">
      <div>
        <div class="defaultLiStyle" @click="insSelect(item,index)" ref="liRef" v-for="(item,index) in groupNames" :key="index">
          {{ item.sname?item.sname:item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HSearch } from 'jpaas-component'
import IconMenuUnfold from '@ant-design/icons/svg/outline/menu-unfold.svg?inline'
import IconMenuFold from '@ant-design/icons/svg/outline/menu-fold.svg?inline'
import IconCaretDown from '@ant-design/icons/svg/outline/caret-down.svg?inline'
import IconCaretRight from '@ant-design/icons/svg/outline/caret-right.svg?inline'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
export default {
  data () {
    return {
      IconCaretRight,
      IconMenuUnfold,
      IconCaretDown,
      IconMenuFold,
      collapsed: false,
      groupData: [],
      visible: false,
      deptLength: 0,
      selectedKeys: [],
      selectGroup: {},
      selectDis: {
        districtId: '',
        districtName: ''
      },
      obj: { name: '', id: '' },
      groupNames: [],
      groupSearchText: '',
      // 传回父组件参数
      districtId: '',
      deptId: '',
      codeId: ''
    }
  },
  components: {
    HSearch
  },
  created () {
    this.selectDis.districtId = sessionStorage.getItem('districtId')
    // this.getGroupList()
  },
  mounted () {
    // this.$emit('getselectDis', this.selectDis)
  },
  methods: {
    onLoadData (treeNode) {
      return new Promise((resolve, reject) => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }
        jiopWebAPI.districtList({ districtId: treeNode.dataRef.iid }).then(res => {
          res.data.districtList = res.data.districtList.map(item => {
            item.isLeaf = !item.hasChild
            return item
          })
          treeNode.dataRef.children = res.data.districtList
          this.groupData = [...this.groupData]
          resolve()
        })

        //
      })
    },
    groupSearch () {
      jiopWebAPI.groupList({ districtId: this.$route.query.districtId, groupName: this.groupSearchText }).then(res => {
        this.groupNames = res.data?.groupList ? res.data.groupList : []
        if (this.groupNames.length > 0) {
          this.groupNames.unshift({ name: '全部', iid: '0' })
        }
      })
    },
    groupClean () {
      this.getGroupList()
    },
    onSelect (value, node, extra) {
      this.selectedKeys = value
      this.visible = false
      this.obj = { iid: value, name: node[0] }
      if (this.obj) {
        this.objTree(this.obj)
      }
    },
    objTree (obj) {
      this.selectDis.districtId = obj.iid
      this.selectDis.districtName = obj.name
      this.getGroupList()
      this.$forceUpdate()
    },
    siderOpen () {
      if (this.collapsed) {
        this.collapsed = !this.collapsed
        this.$emit('siderOpen', false)
      } else {
        this.collapsed = !this.collapsed
        this.$emit('siderOpen', true)
      }
    },

    getGroupList () {
      this.selectGroup = {}
      if (this.selectDis.districtId != null && this.selectDis.districtId !== undefined) {
        jiopWebAPI.groupList({ districtId: this.selectDis.districtId }).then(res => {
          this.groupNames = res.data?.groupList ? res.data.groupList : []
          if (this.groupNames.length > 0) {
            this.groupNames.unshift({ name: '全部', iid: '0' })
          }
          this.insSelect(res.data.groupList && res.data.groupList.length > 0 ? res.data.groupList[0] : {}, 0)
        })
      }
    },
    insSelect (item, index) {
      this.$nextTick(() => {
        this.selectGroup = item
        console.log('===item这个===', item)
        this.$emit('getselectDis', Object.assign({ groupId: item.iid || '0' }, this.selectDis))
        this.$emit('getImpList')
        if (JSON.stringify(item) !== '{}') {
          this.$refs.liRef.map((itemTemp, indexTemp) => {
            if (indexTemp === index) {
              this.$refs.liRef[indexTemp].style.borderRight = ' 6px solid  #1677FF'
              this.$refs.liRef[indexTemp].style.color = '#1677FF'
              // this.$refs.liRef[indexTemp].style.fontWeight='bold'
              this.$refs.liRef[indexTemp].style.borderRightColor = ' rgba(24, 144, 255, 1)'
              this.$refs.liRef[indexTemp].style.backgroundColor = 'rgba(22,119,255,0.10)'
            } else {
              this.$refs.liRef[indexTemp].style.borderRight = ' 0px solid #1677FF'
              this.$refs.liRef[indexTemp].style.color = '#333'
              this.$refs.liRef[indexTemp].style.borderColor = ''
              this.$refs.liRef[indexTemp].style.backgroundColor = ''
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.groupTitle{
  width: 88px;
  height: 24px;

  font-size: 22px;
  color: #000000;
  line-height: 24px;
  font-weight: 500;
}
.insWrapper {
  border-top: 1px solid rgba(238, 238, 238, 1);
}
.defaultLiStyle {
  // border-top: 1px solid #eee;
  height: 46px;
  line-height: 46px;
  cursor: pointer;
  padding-left: 30px;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.defaultLiStyle:first-child {
  border: none;
}
.liiactive {
  border-right: 4px solid #18a9fe !important;
  border-color: rgba(24, 144, 255, 1);
  background-color: rgba(230, 247, 255, 1);
}
.topTool {
  overflow: hidden;
}
.highRowWrap {
  display: flex;
  align-items: center;
  justify-content: space-around;
  .highRowItem {
    width: 25%;
    margin-bottom: 15px;
    span {
      display: inline-block;
      margin-bottom: 5px;
    }
  }
}
.siderTitle {
  height: 40px;
  line-height: 40px;
  width: 240px;
  .contents {
    float: left;
    margin-top: 10px;
    margin-left: 15px;
  }
  .siderIcon {
    margin-top:5px;
    float: right;

    font-size: 14px;
    margin-right:8px;
    margin-bottom: 0;
    color: #999999;
  }
}
</style>
